module.exports = __webpack_public_path__ + "media/images/ui__arrowLeft--dark-5cbe7864a03a45fcca7ca23ec23e7207.png";